import { css } from '@emotion/core'

export const imageSkeleton = (props) => css`
  background: var(--shade);
`

export default imageSkeleton
